import styled, { css } from 'styled-components';

const flexCenteringStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DeleteButton = styled.button<{ disabled?: boolean }>`
  ${flexCenteringStyles}
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 100%;
  background: var(--color-brand-primary-white);
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  visibility: hidden;
`;

export const Image = styled.img`
  display: block;
  width: 100%;
  height: 100%;
`;

export const Card = styled.div<{ $isThumbnail?: boolean }>`
  position: relative;
  overflow: hidden;
  border-radius: 6px;

  :hover {
    ${DeleteButton} {
      visibility: visible;
    }

    ${Image} {
      filter: brightness(70%);
      -webkit-filter: brightness(70%);
    }
  }

  ${({ $isThumbnail }) =>
    $isThumbnail &&
    css`
      width: 115px;
      height: 115px;

      ${Image} {
        object-fit: cover;
      }
    `}
`;
